<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__gamerank}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="活动名称">
          <el-input v-model="dataForm.name" placeholder="请输入活动名称/id" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="dataForm.status" placeholder="全部" clearable>
            <el-option label="已启用" value="1"></el-option>
            <el-option label="已停用" value="2"></el-option>
            <el-option label="已结束" value="3"></el-option>
            <el-option label="待审核" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dataForm.startTime"
            type="datetime"
            value-format="timestamp"
            placeholder="开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="dataForm.endTime"
            type="datetime"
            value-format="timestamp"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addOrUpdateHandle()"
          >新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            @click="deleteHandle()"
          >删除</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;"
      >
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="活动ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="name" label="活动名称" header-align="center" align="center"></el-table-column>
        <el-table-column
          prop="startTime"
          label="活动开始时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          label="活动结束时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column prop="partake" label="参与用户" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.partake.indexOf('mMIN') != -1 " size="small" type="primary">迷你</el-tag>
            <el-tag v-if="scope.row.partake.indexOf('mSTD') != -1 " size="small" type="primary">标准</el-tag>
            <el-tag v-if="scope.row.partake.indexOf('mVIP') != -1 " size="small" type="primary">金钻</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" size="small" type="success">已启用</el-tag>
            <el-tag v-else-if="scope.row.status === 2" size="small" type="warning">已停用</el-tag>
            <el-tag v-else-if="scope.row.status === 3" size="small" type="info">已结束</el-tag>
            <el-tag v-else-if="scope.row.status === 4" size="small" type="danger">待审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="updateDate"
          label="更新时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column prop="sum" label="参与用户数" header-align="center" align="center"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          header-align="center"
          align="center"
          width="170"
        >
          <template slot-scope="scope">
<!--            <span v-if="scope.row.status==1">-->
            <el-button type="text" size="small" @click="openBlack(scope.row.id)">黑名单</el-button>
<!--            </span>-->
            <el-button  type="text" size="small" @click="detailHandel(scope.row)">详情</el-button>
            <el-button  type="text" size="small" @click="copyHandle(scope.row.id)">复制</el-button>
              <el-button type="text" size="small" @click="uploadHandle(scope.row.id)">参与用户</el-button>
            <span v-if="scope.row.status == 4">
              <el-button
                type="text"
                size="small"
                @click="addOrUpdateHandle(scope.row.id)"
              >修改</el-button>
            </span>
            <span v-else>
              <el-button
                type="text"
                size="small"
                @click="addOrUpdateHandle(scope.row.id)"
              >活动细则</el-button>
            </span>
            <el-button
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
            >删除</el-button>
            <span v-if="scope.row.status == 1">
              <el-button
                style="margin-left: 10px"
                type="text"
                size="small"
                @click="updateStatusHandle(scope.row.id, scope.row.status)"
              >停用</el-button>
            </span>
            <span v-else-if="scope.row.status == 2">
              <el-button
                style="margin-left: 10px"
                type="text"
                size="small"
                @click="updateStatusHandle(scope.row.id, scope.row.status)"
              >启用</el-button>
            </span>
            <span v-else-if="scope.row.status == 3">
              <el-button
                style="margin-left: 10px"
                type="text"
                size="small"
                @click="updateStatusHandle(scope.row.id, scope.row.status)"
              >已结束</el-button>
            </span>
            <span v-else-if="scope.row.status == 4">
              <el-button
                style="margin-left: 10px"
                type="text"
                size="small"
                @click="updateStatusHandle(scope.row.id, scope.row.status)"
              >审核</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      ></el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" 
      @refreshDataList="getDataList"
      :productList="productList"

      ></add-or-update>
    </div>
    <el-dialog title="导入黑名单"  :visible.sync="blackFormVisible" width="500px">
      <el-form label="黑名单">
        <el-col :span="1">
          <el-input v-model="dataForm.userList" placeholder="黑名单" style="width: 180px" disabled></el-input>
        </el-col>
        <el-col :span="2" style="padding-left: 180px;">
          <el-upload action="/" :on-change='onChange' :auto-upload='false' :show-file-list="false" accept=".xls, .xlsx">
            <el-button size="small" type="primary">上传</el-button>
          </el-upload>
        </el-col>
        <el-col style="padding-top: 10px">
          <a href="https://img.getfc.com.cn/source/excel/user_template.xlsx" class="el-button el-button--success el-button--default is-plain">下载模板</a>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="blackFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="importBlack">确 定</el-button>
      </div>
    </el-dialog>
      <!-- 弹窗, 上传文件 -->
      <GameuserUpload v-if="uploadVisible" :gameRankId="gameRankId" ref="upload"></GameuserUpload>
  </el-card>
</template>

<script>
import Qs from 'qs';
import mixinViewModule from "./import/view-module";
import AddOrUpdate from "./gamerank-add-or-update";
import XLSX from 'xlsx';
import Url from '@/views/crs/util/url'
import GameuserUpload from "./components/gameuser-upload";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: Url.gameRank.base+"/activity/gameRank/page?lang=cn",
        getDataListIsPage: true,
        deleteURL: Url.gameRank.base+"/activity/gameRank",
        deleteIsBatch: true
      },
      dataForm: {
        id: "",
        userList: "",
      },
      blackFormVisible: false,
      productList:[],
      selectList: {
        createList: [] //创建者列表
      },
      uploadVisible: false,
      gameRankId:'',
      token:''
    };
  },
  components: {
    AddOrUpdate,
    GameuserUpload
  },
  mounted() {
    /*const url = Url.gameRank.base+"/activity/gameRank/selectList";
    this.$http.get(url).then(res => {
      if (res.data.code == 0) {
        this.selectList.createList = res.data.data;
      }
    });*/
    this.getDataList();
  },
  methods: {
    // 复制
    copyHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.dataForm.id = id
        this.$refs.addOrUpdate.initCopy()
      })
    },
    updateStatusHandle(id, status) {
      let msg = "";
      let sta = 0;
      if (status == 3) {
        this.$message.error("活动已经结束！");
        return;
      } else if (status == 4) {
        msg = "确定审核成功吗？ 若确认后则无法修改活动细则。";
        sta = 1;
      } else if (status == 1) {
        msg = "确定将活动状态改为禁用吗？";
        sta = 2;
      } else if (status == 2) {
        sta = 1;
        msg = "确定将活动状态改为启用吗？";
      } else {
        return;
      }
      this.$confirm(msg, "修改活动状态", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.updateStatus(id, sta);
      });
    },
    updateStatus(id, status) {
      this.$axios
        .get(Url.gameRank.base+"/activity/gameRank/updateStatus?id=" + id + "&status=" + status)
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          } else {
            this.$message({
              message: "更新状态成功",
              type: "success",
              duration: 500,
              onClose: () => {
                this.getDataList();
              }
            });
          }
        })
        .catch(() => {});
    },
    detailHandel(row) {
      this.$router.push({path: `/crs/gameRank/gamerankuser?label=CRS&id=${row.id}&tagname=${row.name}`})
    },
    // 文件选择回调
    onChange(file, fileList) {
      this.fileData = file // 保存当前选择文件
      this.readExcel() // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      let that = this;
      const files = that.fileData;
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          that.userList = []; //清空接收数据
          for (var i = 0; i < ws.length; i++) {
            var sheetData = ws[i]['交易账号'];
            that.userList.push(sheetData);
          }
          that.dataForm.userList = that.userList.join()
          //this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
    //打开浮窗
    openBlack(id){
      this.blackFormVisible = true;
      this.dataForm.gameRankId=id;
      this.dataForm.userList="";
    },
      // 上传文件
      uploadHandle (id) {
          this.gameRankId = id
          this.uploadVisible = true
          this.$nextTick(() => {
              this.$refs.upload.init()
          })
      },
    //添加黑名单
    importBlack(){
      this.blackFormVisible = false;
      this.$axios({
            headers:{'Content-Type':'application/json'},
            method: 'post',
            url:Url.gameRank.base+"/activity/gameRank/importBlack", 
            data:this.dataForm
          }).then(res => {
                if (res.code !== 0) {
                  return this.$message.error(res.msg);
                } else {
                  this.$message({
                    message: "添加黑名单成功",
                    type: "success",
                    duration: 500
                  });
                }
              })
              .catch(() => {});
    }
  }
};
</script>
